import React from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";
import { XCircleIcon } from "@heroicons/react/24/outline";

interface ForgotPasswordDialogProps {
  open: boolean;
  onClose: () => void;
}

export const ForgotPasswordDialog: React.FC<ForgotPasswordDialogProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      size="xs"
      open={open}
      handler={onClose}
      className="bg-transparent shadow-none"
    >
      <Card className="mx-auto w-full max-w-[24rem]">
        <CardBody className="flex flex-col gap-4">
          <XCircleIcon
            className="absolute w-7 right-5 top-5 cursor-pointer"
            onClick={onClose}
          />
          <Typography variant="h4" color="blue-gray">
            忘记密码
          </Typography>
          <Typography
            className="mb-3 font-normal"
            variant="paragraph"
            color="gray"
          >
            如需修改密码，请联系客服协助处理
          </Typography>
          <div className="bg-blue-50 p-4 rounded-lg">
            <Typography
              variant="small"
              color="blue-gray"
              className="font-medium"
            >
              客服联系方式：
            </Typography>
            <Typography variant="small" color="blue-gray" className="mt-2">
              联系下单平台客服提供账号修改密码
            </Typography>
          </div>
        </CardBody>
        <CardFooter className="pt-0">
          <Button variant="gradient" onClick={onClose} fullWidth>
            我知道了
          </Button>
        </CardFooter>
      </Card>
    </Dialog>
  );
};
